export default __webpack_public_path__ + "static/media/4.0759090e.jpeg";